export enum ResultsView {
  LIST = 'list',
  MAP = 'map',
}
